// Central brand & contact configuration. Edit to update across the entire site.

// Official BURLY brand logo, navy wordmark with horse in the R (local, optimized).
export const LOGO_URL = "/brand/logo.png";

// Inverse logo, white wordmark on transparent background (local, optimized).
// Used in the footer so the BURLY mark sits directly on the navy surface.
export const LOGO_INVERSE = "/brand/logo-white.png";

export const SOCIALS = [
  { label: "LinkedIn", url: "https://www.linkedin.com/company/burly-sinks" },
  { label: "Facebook", url: "https://www.facebook.com/burlyseramik" },
  { label: "Instagram", url: "https://www.instagram.com/burlyseramik/" },
];

// Four lifestyle photographs for the auto-rotating hero on the landing page.
export const HERO_LIFESTYLE = [
  {
    src: "/hero/hero-1.jpg",
    alt: "Modern kitchen with grey uppers, navy lowers, white fluted apron-front Burly fireclay sink, and mountain view",
  },
  {
    src: "/hero/hero-2.jpg",
    alt: "Close-up of Burly white fluted apron-front fireclay farmhouse sink with copper spring faucet on subway tile",
  },
  {
    src: "/hero/hero-3.jpg",
    alt: "Burly BS361810SBR fluted apron-front fireclay sink in a deep navy kitchen with brass bridge faucet",
  },
  {
    src: "/hero/hero-4.jpg",
    alt: "Burly BS361810DBR flat apron-front fireclay sink with brass gooseneck bridge faucet in a navy kitchen",
  },
];

// Real factory photograph supplied by the client, used wherever a manufacturing
// / craft image is needed across the site.
export const FACTORY_IMG =
  "/img/factory.jpg";

// Four manufacturing photos for the dedicated B&W manufacturing gallery.
export const MFG_PHOTOS = [
  {
    src: "/img/mfg-kiln-gas.jpg",
    caption: "Kiln & gas system",
    alt: "Industrial gas distribution and kiln control system at the Burly manufacturing plant",
  },
  {
    src: "/img/mfg-slip-cast.jpg",
    caption: "Slip cast greenware",
    alt: "Freshly slip-cast fireclay greenware on its plaster mould before bisque firing",
  },
  {
    src: "/img/mfg-fluted-apron.jpg",
    caption: "Fluted apron detail",
    alt: "Close-up of the fluted apron front of a Burly fireclay farmhouse sink",
  },
  {
    src: "/img/mfg-mould.jpg",
    caption: "33-inch mould",
    alt: "33-inch fireclay sink plaster mould ready for slip pouring",
  },
];

// Hero & lifestyle photography, supplied by the client.
export const LIFESTYLE_KITCHEN_NAVY =
  "/img/lifestyle-kitchen-navy.jpg";
export const PRODUCT_FLUTED_BRONZE =
  "/img/fluted-bronze.jpg";
export const PRODUCT_DOUBLE_BOWL_POTS =
  "/img/double-bowl-pots.jpg";
export const PRODUCT_UTILITY_CYLINDERS =
  "/img/double-bowl-pots-2.jpg";

export const SITE = {
  brand: "Burly",
  legal_name: "Burly Seramik Limited",
  domain: "bburly.com",
  tagline: "Premium Fine Fireclay Sinks",
  brand_line: "American Innovation · Indian Manufacturing Excellence",
  short_pitch:
    "Burly combines American design inspiration with India's renowned fireclay manufacturing expertise to create premium kitchen sinks and bathroom basins trusted by architects, distributors, and homeowners worldwide.",
  email: "reach@bburly.com",
  phone_display: "+91 98980 67267",
  phone_e164: "+919898067267",
  whatsapp_e164: "919898067267",
  // Registered office in the United States
  registered_office: {
    label: "Registered Office (USA)",
    line1: "Burly",
    line2: "New Jersey",
    region: "United States",
  },
  // Corporate / Indian office
  corporate_office: {
    label: "Corporate Office (India)",
    line1: "1317, 13th Floor, Lobby 2, Sakar IX",
    line2: "Ashram Road",
    region: "Ahmedabad, Gujarat 380009, India",
  },
  // Manufacturing plant
  address: {
    line1: "Burly Seramik Limited",
    line2: "Survey No. 1412, Muktipura Road, Navagam",
    region: "Bareja, Gujarat 382425, India",
  },
  hours: [
    { day: "Mon – Sat", time: "8:30 AM – 6:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
  founded: 2021,
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/products/" },
  { label: "Manufacturing", to: "/manufacturing/" },
  { label: "Quality", to: "/quality/" },
  { label: "About", to: "/about/" },
  { label: "Journal", to: "/blog/" },
  { label: "FAQ", to: "/faq/" },
  { label: "Contact", to: "/contact/" },
];
